import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";
import { GET_ORGANIZATION_APPS } from "../organization/getOrganizationApps";

const CREATE_APP = gql(`
  mutation CREATE_APP($organizationSlug: String!, $appData: AppCreateInfo!) {
  appCreate(organizationSlug: $organizationSlug, appData: $appData) {
    id
    slug
    displayName
    description
    createdAt
  }
}
`);

export function useCreateApp() {
  return useMutation(CREATE_APP, {
    refetchQueries: [GET_ORGANIZATION_APPS]
  });
}
